export function buildProjectUrl(customUrlPath, projectHash) {
    const domain = process.env.REACT_APP_SSR_URL
    const path = customUrlPath ? customUrlPath : projectHash
    return `${domain}/projects/${path}`
}
